import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=f86b7e40&scoped=true&"
import script from "./Faq.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Faq.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86b7e40",
  null
  
)

export default component.exports